import { useState, useEffect, useRef } from "react";
import "../Assests/Leave_tracker.css";
import {
  addLeave,
  getLeavesByProfile,
  getLeaves,
} from "../Db_Connections/leavesApi";

export default function LeaveTracker() {
  const [showModal, setShowModal] = useState(false);

  // Database Data States
  const [leaves, setLeaves] = useState([]);
  const [loading, setLoading] = useState(true);

  // User Session
  const user = JSON.parse(sessionStorage.getItem("auth"));
  const isAdmin = user?.role === "Admin";

  const [formData, setFormData] = useState({
    leaveType: "",
    startDate: "",
    endDate: "",
    reason: "",
  });
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  // Total Quota
  const leaveQuota = {
    "Casual Leave": 12,
    "Sick Leave": 12,
  };
  // ✅ ADD: today/tomorrow helpers (define minStartDate)
  const formatDateInput = (d) => {
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const todayDate = new Date();
  todayDate.setHours(0, 0, 0, 0);

  const tomorrowDate = new Date(todayDate);
  tomorrowDate.setDate(tomorrowDate.getDate() + 1);

  const minStartDate = formatDateInput(tomorrowDate);
  // ✅ ADD END
  

  // --- DATA LOAD FUNCTION ---
  const loadLeaves = async () => {
    if (!user) return;
    setLoading(true);
    let result;

    if (isAdmin) result = await getLeaves();
    else result = await getLeavesByProfile(user.id);

    if (result.error) console.error(result.error);
    else setLeaves(result.data || []);

    setLoading(false);
  };

  // ✅ API ko sirf ek hi baar call karne ka guard
  const hasLoadedRef = useRef(false);

  useEffect(() => {
    if (hasLoadedRef.current) return;
    hasLoadedRef.current = true;

    loadLeaves();  
  }, []);

  // --- CALCULATE BALANCE (only for user UI) ---
const getLeaveStats = (type) => {
  const total = 2; // monthly combined limit

  const myLeaves = isAdmin
    ? leaves.filter((l) => l.profile_id === user.id)
    : leaves;

  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth();

  // ✅ Current month ki valid Sick/Casual leaves
  const currentMonthLeaves = myLeaves.filter((l) => {
    const leaveDate = new Date(l.start_date);
    return (
      leaveDate.getFullYear() === currentYear &&
      leaveDate.getMonth() === currentMonth &&
      l.status !== "Rejected" &&
      (l.leave_type === "Casual Leave" || l.leave_type === "Sick Leave")
    );
  });

  // ✅ Combined total used this month
  const totalUsed = currentMonthLeaves.length;

  // ✅ Current card/type used
  const typeUsed = currentMonthLeaves.filter(
    (l) => l.leave_type === type
  ).length;

  return {
    name: type,
    available: Math.max(0, total - totalUsed),
    booked: typeUsed,
    total: total,
    icon: type === "Casual Leave" ? "🏖️" : "🏥",
    color: type === "Casual Leave" ? "#e3f2fd" : "#f3e5f5",
  };
};

  const leaveTypes = [
    getLeaveStats("Casual Leave"),
    getLeaveStats("Sick Leave"),
  ];

  // --- ADMIN: EMPLOYEE WISE SUMMARY ---
  const getEmployeeLeaveSummary = () => {
    const summary = {};

    leaves.forEach((l) => {
      const name = l?.profiles
        ? `${l.profiles.first_name || ""} ${l.profiles.last_name || ""}`.trim()
        : `Employee (${l.profile_id})`;

      if (!summary[name])
        summary[name] = { name, totalDays: 0, totalRequests: 0 };

      // Rejected ko ignore
      if (l.status !== "Rejected") {
        summary[name].totalDays += Number(l.total_days || 0);
      }
      summary[name].totalRequests += 1;
    });

    return Object.values(summary).sort((a, b) => b.totalDays - a.totalDays);
  };

  // --- HANDLERS ---
  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setMessage("");
  };

const handleSubmit = async () => {
  if (isAdmin) return;

  const { leaveType, startDate, endDate, reason } = formData;

  if (!leaveType || !startDate || !endDate) {
    setMessage("Please fill all required fields.");
    setMessageType("error");
    return;
  }

  const start = new Date(startDate + "T00:00:00");
  const end = new Date(endDate + "T00:00:00");

  // ✅ aaj ya past block (tomorrow se pehle kuch bhi allow nahi)
  if (startDate < minStartDate) {
    setMessage("You cannot apply leave for today or past dates. Please select a future date.");
    setMessageType("error");
    return;
  }

  if (end < start) {
    setMessage("End Date cannot be before Start Date.");
    setMessageType("error");
    return;
  }

  const diffDays = Math.floor((end - start) / (1000 * 60 * 60 * 24)) + 1;

  
  const stats = getLeaveStats(leaveType);

  if (diffDays > stats.available) {
    setMessage(`Only ${stats.available} leave(s) available.`);
    setMessageType("error");
    return;
  }

  const { error } = await addLeave({
    profile_id: user.id,
    leave_type: leaveType,
    start_date: startDate,
    end_date: endDate,
    total_days: diffDays,
    reason: reason,
  });

  if (error) {
    setMessage(error.message);
    setMessageType("error");
  } else {
    setMessage("Leave applied successfully!");
    setMessageType("success");

    setTimeout(() => {
      setShowModal(false);
      setFormData({
        leaveType: "",
        startDate: "",
        endDate: "",
        reason: "",
      });
      setMessage("");
      loadLeaves();
    }, 1000);
  }
};
  //   if (isAdmin) return;

  //   const { leaveType, startDate, endDate, reason } = formData;

  //   if (!leaveType || !startDate || !endDate) {
  //     alert('Please fill all required fields.');
  //     return;
  //   }

  //   const start = new Date(startDate);
  //   const end = new Date(endDate);
  //   if (end < start) {
  //     alert('End Date cannot be before Start Date.');
  //     return;
  //   }

  //   const diffDays = Math.floor((end - start) / (1000 * 60 * 60 * 24)) + 1;

  //   const stats = getLeaveStats(leaveType);
  //   // if (diffDays > stats.available) {
  //   //   alert(`Insufficient Balance! You only have ${stats.available} days remaining.`);
  //   //   return;
  //   // }

  //   const { error } = await addLeave({
  //     profile_id: user.id,
  //     leave_type: leaveType,
  //     start_date: startDate,
  //     end_date: endDate,
  //     total_days: diffDays,
  //     reason: reason
  //   });

  //   if (error) {
  //     alert('Error: ' + error.message);
  //   } else {
  //     alert('Leave applied successfully!');
  //     setShowModal(false);
  //     setFormData({ leaveType: '', startDate: '', endDate: '', reason: '' });
  //     loadLeaves();
  //   }
  // };

  // --- RENDER HELPERS ---
  const renderLeaveSummary = () => (
    <>
      {/* ✅ User only: quota cards */}
      {!isAdmin && (
        <div className="leave-cards">
          {leaveTypes.map((leave, index) => (
            <div className="leave-card" key={index}>
              <div className="leave-card-header">
                <div className="leave-card-title">{leave.name}</div>
                <div className="leave-icon" style={{ background: leave.color }}>
                  {leave.icon}
                </div>
              </div>
              <div className="leave-stats">
                <div className="leave-stat-row">
                  <span className="leave-stat-label">Available</span>
                  <span
                    className={`leave-stat-value ${leave.available < 3 ? "orange" : "green"}`}
                  >
                    {leave.available}
                  </span>
                </div>
                <div className="leave-stat-row">
                  <span className="leave-stat-label">Used/Pending</span>
                  <span className="leave-stat-value">{leave.booked}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      <div className="upcoming-section">
        <div className="section-header">
          <span className="section-title">
            {isAdmin ? "Employee Leave Summary" : "My Recent Leaves"}
          </span>
        </div>

        {loading ? (
          <p>Loading...</p>
        ) : leaves.length === 0 ? (
          <div className="empty-state">
            <div>No Data Found</div>
          </div>
        ) : (
          <>
            {/* ✅ Admin: employee-wise summary */}
            {isAdmin && (
              <div className="table-wrapper">
                <table className="leave-table" style={{ width: "100%" }}>
                  <thead>
                    <tr>
                      <th>Employee</th>
                      <th>Total Requests</th>
                      <th>Total Days (Approved + Pending)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getEmployeeLeaveSummary().map((row) => (
                      <tr key={row.name}>
                        <td>{row.name}</td>
                        <td>{row.totalRequests}</td>
                        <td>{row.totalDays}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* ✅ Admin + User: recent leaves list */}
            <div className="leave-list-simple">
              {leaves.slice(0, isAdmin ? 20 : 5).map((leave) => (
                <div
                  key={leave.id}
                  className="request-card"
                  style={{ margin: "10px 0" }}
                >
                  <div className="request-info">
                    <div className="request-details">
                      {isAdmin && leave.profiles && (
                        <div
                          style={{
                            fontWeight: "bold",
                            color: "#333",
                            marginBottom: "4px",
                          }}
                        >
                          👤 {leave.profiles.first_name}{" "}
                          {leave.profiles.last_name}
                        </div>
                      )}
                      <h4>{leave.leave_type}</h4>
                      <p>
                        {leave.start_date} to {leave.end_date} (
                        {leave.total_days} days)
                      </p>
                    </div>
                  </div>
                  <div className="request-status">
                    <span
                      className={`status-badge ${leave.status.toLowerCase()}`}
                    >
                      {leave.status}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </>
  );

  return (
    <div className="leave-tracker-container">
      <div className="content-area">
        <div className="summary-header">
          <div className="summary-stats">
            <span></span>
          </div>

          {/* ✅ Admin: Apply button hide */}
          {!isAdmin && (
            <div className="header-controls">
              <button
                className="apply-leave-btn"
                onClick={() => setShowModal(true)}
              >
                Apply Leave
              </button>
            </div>
          )}
        </div>

        {renderLeaveSummary()}
      </div>

      {/* ✅ Admin: modal disable */}
      {!isAdmin && showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2 className="modal-title">Apply Leave</h2>
              <button className="close-btn" onClick={() => setShowModal(false)}>
                ×
              </button>
            </div>

            <div className="modal-body">
              {message && (
                <div
                  style={{
                    color: messageType === "error" ? "red" : "green",
                    marginBottom: "10px",
                  }}
                >
                  {message}
                </div>
              )}
              <div className="form-group">
                <label className="form-label">Leave Type *</label>
                <select
                  className="form-select"
                  name="leaveType"
                  value={formData.leaveType}
                  onChange={handleInputChange}
                >
                  <option value="">Select leave type</option>
                  <option value="Casual Leave">Casual Leave</option>
                  <option value="Sick Leave">Sick Leave</option>
                </select>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Start Date *</label>
                  <input
                    type="date"
                    className="form-input"
                    name="startDate"
                    value={formData.startDate}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">End Date *</label>
                  <input
                    type="date"
                    className="form-input"
                    name="endDate"
                    value={formData.endDate}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Reason</label>
                <textarea
                  className="form-textarea"
                  name="reason"
                  value={formData.reason}
                  onChange={handleInputChange}
                  placeholder="Reason..."
                ></textarea>
              </div>
            </div>

            <div className="modal-footer">
              <button
                className="btn-secondary"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>
              <button className="btn-primary" onClick={handleSubmit}>
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
